/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkthrough_Btn_NextInputs */

const es_walkthrough_btn_next = /** @type {(inputs: Walkthrough_Btn_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siguiente`)
};

const en_walkthrough_btn_next = /** @type {(inputs: Walkthrough_Btn_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next`)
};

/**
* | output |
* | --- |
* | "Next" |
*
* @param {Walkthrough_Btn_NextInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const walkthrough_btn_next = /** @type {((inputs?: Walkthrough_Btn_NextInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkthrough_Btn_NextInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_walkthrough_btn_next(inputs)
	return en_walkthrough_btn_next(inputs)
});
export { walkthrough_btn_next as "walkthrough.btn_next" }